/* global axios */

import ApiClient from './ApiClient';

class WhatsappAppTemplatesAPI extends ApiClient {
  constructor() {
    super('whatsapp_app_templates', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  testSend(
    id,
    { contact_phone, placeholder_values, content, interactive_config, inbox_id }
  ) {
    return axios.post(`${this.url}/${id}/test_send`, {
      contact_phone,
      placeholder_values,
      content,
      interactive_config,
      inbox_id,
    });
  }
}

export default new WhatsappAppTemplatesAPI();
